// extracted by mini-css-extract-plugin
module.exports = {"tags":"tag-list-module--tags--3uJ7V"};